// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assests/clientdashboard/accountsetting/account-banner-img.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header background section */
.Account_header__aAD5p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace with actual image URL */
  background-size: cover;
  background-position: center;
  height: 200px; /* Adjust as needed */
  width: 99%;
  position: relative;
  border-radius: 0.8rem;
  margin-right: 1rem;
}

/* Profile image overlapping on the header */
.Account_profileImage__vzeO3 {
  position: absolute;
  left: 20px;
  bottom: -40px; /* Adjust to overlap image on the header */
  height: 80px;
  width: 80px;
  border-radius: 50%;
  border: 3px solid white;
  background-color: white;
}

/* Main container for form section */
.Account_accountFormContainer__qZETH {
  /* background-color: rgb(240, 183, 183); */
  margin-top: 60px;
  flex: 1 1;
  border-radius: 0.8rem;
  width: 99%;
}

/* Root element to set the entire page height */
.Account_root__v4Fjn {
  /* height: 80vh; */
  display: flex;
  flex-direction: column;
}

/* Button container with horizontal scrolling */
.Account_buttonContainer__UimQG {
  padding: 0.8rem 0rem 0.8rem 0.4rem;
  overflow-x: auto; /* Enables horizontal scrolling */
}

/* profile section */
.Account_profileContainer__O8oFt {
  padding: 20px;
  border-radius: 8px;
}
.Account_profileHeader__RVMvh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.Account_heading__4y4Gw {
  font-size: 1.5rem;
  font-weight: bold;
}

.Account_editButton__zADNK {
  text-align: right;
}

@media (max-width: 600px) {
  .Account_profileContainer__O8oFt {
    padding: 10px;
  }

  .Account_editButton__zADNK {
    text-align: center;
  }
  .Account_notificationsContainer__B0vbD {
    padding: 15px;
  }

  .Account_switchContainer__u7lhG {
    text-align: left;
  }
  .Account_section__PCX7K {
    width: 100%;
  }
}

.Account_notificationsContainer__B0vbD {
  padding: 20px;
  background-color: #fff;
}

.Account_heading__4y4Gw {
  font-weight: bold;
  margin-bottom: 10px;
}

.Account_description__soNXp {
  color: #6e6e6e;
  margin-bottom: 20px;
}

.Account_section__PCX7K {
  margin-bottom: 30px;
  width: 50%;
}

.Account_subheading__9POcJ {
  font-weight: bold;
  margin-bottom: 15px;
}

.Account_notificationItem__Xhf4h {
  align-items: center;
}

.Account_switchContainer__u7lhG {
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/RFPDashboard/AccountSetting/Account.module.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,yDAA8F,EAAE,kCAAkC;EAClI,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa,EAAE,qBAAqB;EACpC,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa,EAAE,0CAA0C;EACzD,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,SAAO;EACP,qBAAqB;EACrB,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,kCAAkC;EAClC,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/* Header background section */\n.header {\n  background-image: url(\"/public/assests/clientdashboard/accountsetting/account-banner-img.png\"); /* Replace with actual image URL */\n  background-size: cover;\n  background-position: center;\n  height: 200px; /* Adjust as needed */\n  width: 99%;\n  position: relative;\n  border-radius: 0.8rem;\n  margin-right: 1rem;\n}\n\n/* Profile image overlapping on the header */\n.profileImage {\n  position: absolute;\n  left: 20px;\n  bottom: -40px; /* Adjust to overlap image on the header */\n  height: 80px;\n  width: 80px;\n  border-radius: 50%;\n  border: 3px solid white;\n  background-color: white;\n}\n\n/* Main container for form section */\n.accountFormContainer {\n  /* background-color: rgb(240, 183, 183); */\n  margin-top: 60px;\n  flex: 1;\n  border-radius: 0.8rem;\n  width: 99%;\n}\n\n/* Root element to set the entire page height */\n.root {\n  /* height: 80vh; */\n  display: flex;\n  flex-direction: column;\n}\n\n/* Button container with horizontal scrolling */\n.buttonContainer {\n  padding: 0.8rem 0rem 0.8rem 0.4rem;\n  overflow-x: auto; /* Enables horizontal scrolling */\n}\n\n/* profile section */\n.profileContainer {\n  padding: 20px;\n  border-radius: 8px;\n}\n.profileHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.heading {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.editButton {\n  text-align: right;\n}\n\n@media (max-width: 600px) {\n  .profileContainer {\n    padding: 10px;\n  }\n\n  .editButton {\n    text-align: center;\n  }\n  .notificationsContainer {\n    padding: 15px;\n  }\n\n  .switchContainer {\n    text-align: left;\n  }\n  .section {\n    width: 100%;\n  }\n}\n\n.notificationsContainer {\n  padding: 20px;\n  background-color: #fff;\n}\n\n.heading {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.description {\n  color: #6e6e6e;\n  margin-bottom: 20px;\n}\n\n.section {\n  margin-bottom: 30px;\n  width: 50%;\n}\n\n.subheading {\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.notificationItem {\n  align-items: center;\n}\n\n.switchContainer {\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Account_header__aAD5p`,
	"profileImage": `Account_profileImage__vzeO3`,
	"accountFormContainer": `Account_accountFormContainer__qZETH`,
	"root": `Account_root__v4Fjn`,
	"buttonContainer": `Account_buttonContainer__UimQG`,
	"profileContainer": `Account_profileContainer__O8oFt`,
	"profileHeader": `Account_profileHeader__RVMvh`,
	"heading": `Account_heading__4y4Gw`,
	"editButton": `Account_editButton__zADNK`,
	"notificationsContainer": `Account_notificationsContainer__B0vbD`,
	"switchContainer": `Account_switchContainer__u7lhG`,
	"section": `Account_section__PCX7K`,
	"description": `Account_description__soNXp`,
	"subheading": `Account_subheading__9POcJ`,
	"notificationItem": `Account_notificationItem__Xhf4h`
};
export default ___CSS_LOADER_EXPORT___;
